//This component will show  save filters in the UI  and you can save too.
import React from "react";
import reqwest from "reqwest";
import axios from "axios";
import {
  Slider,
  Row,
  Col,
  Card,
  Select,
  Button,
  Modal,
  List,
  Input,
  Popconfirm,
  Progress
} from "antd";
import { connect } from "react-redux";
import { activateDatadic,activateScreen,activateFiname,activateRecord,activateStocks   } from "../redux";
import { CloseCircleTwoTone, PoweroffOutlined,QuestionCircleOutlined } from "@ant-design/icons";
const data = [];

const { Option } = Select;
 

class SaveFilterclass extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      value: "",
      data: [],
      isModalVisible: false,
      setIsModalVisible: false,
      loading: false,
      savefill: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlesave = this.handlesave.bind(this);
    this.handlload = this.handlload.bind(this);
    this.handledel = this.handledel.bind(this);
  }
  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    reqwest({
      url: this.props.apppath + "/include/api/screener/Simsaveload.cfm?uid="+this.props.auid ,
      method: "get",
      type: "json",
    }).then((data) => {
      

      this.setState({
        data: data.results,
        loading: false,
      });
    });
  }





  fetch = (params = {}) => {
    this.setState({ loading: true });
    reqwest({
      url: "https://siproupdateonly.s3-accelerate.amazonaws.com/stockScreenerInit.json",
      method: "get",
      type: "json",
   
    }).then((data) => {
      this.props.activateStocks(data.screenRating);

      this.props.activateRecord(data.screenRating.length);

      this.setState({
        loading: false,
      
      });
    });
  };




  handle(response=2) {
    if (response ==0){
      alert('This name is in use, please use a new screen name.');
      this.setState({
        loading: false,
        savefill: false,
      });
    }else {

    this.setState({
      loading: true,
    });
    reqwest({
      url: this.props.apppath + "/include/api/screener/Simsaveload.cfm?uid="+this.props.auid,
      method: "get",
      type: "json",
    }).then((data) => {
 
      this.props.activateFiname(this.state.value);
      this.setState({
        data: data.results,
        loading: false,
        savefill: false,
      });
    });


  }
  }

  handlload(id) {
    this.setState({
      loading: true,
    });
    
    this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[id].FILTER_),
    });
    this.props.activateFiname(this.state.data[id].NAME_);
    
   
    this.setState({
      loading: false,
      isModalVisible:false,
    });
    this.fetch();
  }

  handledel(id) {
    this.setState({
      loading: true,
    });
    const del = { filterid: id, userId: this.props.auid };
    axios
      .post(this.props.apppath + "/include/api/screener/Simdel.cfm", del)
      .then((response) => this.handle());
  }
  handlesave() {
    this.setState({
      loading: true,
      savefill: true,
    });
  
    const article = {
      filter: this.props.datadic.FilterDic,
      filterName: this.state.value,
      userId: this.props.auid,
    };
    axios
      .post(this.props.apppath + "/include/api/screener/Simsave.cfm", article)
      .then((response) => this.handle(response.data.results[0].ACT),);
  }


  HandleReq(id) {
    this.setState({
      lookingTickers: true,
      runscreen:true,
    });

/*     this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[id].FILTER_),
    });
    this.props.activateFiname(this.state.data[id].NAME_); */


    this.props.activateScreen(true);
    this.setState({
      count: 40,
    });

    this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[id].FILTER_),
    });
    this.props.activateFiname(this.state.data[id].NAME_);


    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables:  [JSON.parse(this.state.data[id].FILTER_)] }),
   
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json()
      )
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data.filteredData,
            lookingTickers: false,
            runscreen:false,
            count: 60,
          },
          () => {
            this.props.activateRecord(data.filteredData.length);
            this.props.activateStocks(data.filteredData )
            this.props.activateScreen(false);
            this.setState({count:100})
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
     

        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
            this.props.activateScreen(false);
            

          }
        );
      });
  }
  render() {
    const handleOk = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

    const handleCancel = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

    const showModal = () => {
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
      });
    };

    let  dsihide='';
    let  dsihide2='';

    if(this.props.screen==false){
      dsihide = {
     
      display: 'none',
    };
    dsihide2 = {
     
      display: '',
    };
  }else{
      dsihide = {
     
      display: '',
    };
    dsihide2 = {
     
      display: 'none',
    };
  }
    return (
      <div>
        <Button style={{display:'none'}}  type="primary"  onClick={showModal}>
          Save Screen
        </Button>

        <Modal
          title="Save Screen"
          visible={this.state.isModalVisible}
          onCancel={handleCancel}

          footer={[
            <Button key="back" type="primary"  onClick={handleCancel}>
              Close
            </Button>,
             ]}
         
        >

          
<div style={dsihide}>
              Running Screen........
                <Progress
                 
            size="small" 
      strokeColor={{
        '0%': '#108ee9',
        '100%': '#87d068',
      }}
      percent={this.state.count}
      status="active"
      showInfo={false}
      strokeLinecap='square'
      
    /></div> 

<div style={dsihide2}>
          <Input
            placeholder=""
            onChange={this.handleChange}
            style={{ width: "50%" }}
          />
          <Button
            loading={this.state.savefill}
            onClick={this.handlesave}
            type="primary"
          >
            Save
          </Button>


          
          <List
            itemLayout="horizontal"
            dataSource={this.state.data}
            loading={this.state.loading}
            renderItem={(item) => (
              <List.Item>
              <List.Item.Meta title={item.NAME_} description="" />
              <List.Item
                actions={[
                  <Button 
                  key={item.cid}
                  id={item.cid}
                  onClick={() =>    this.HandleReq(item.cid) }
                  loading={this.props.screen}
                >
                  Run Screen
                </Button>,
                   /* <Button
                    key={item.cid}
                    id={item.cid}
                    onClick={() => this.handlload(item.cid)}
                  >
                    Edit Filter
                  </Button>, */ 
                   <Popconfirm     title="Are you sure to delete this Screen?"  
                   okText="Yes"
                    cancelText="No"
                   id={item.id} onConfirm={() => this.handledel(item.id)}   icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
                  <Button danger
                    id={item.id}
                    onClick={this.showPopconfirm}
                    key={item.id}
                  >
                    Delete
                  </Button></Popconfirm>,
                ]}
              >
                {" "}
              </List.Item>
            </List.Item>
            )}
          />  </div>
        </Modal>
      </div>
    );
  }
}
 

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  stocks: state.stocks,
  record: state.record,
  auid: state.auid,
  screen: state.screen,
});

const mapDispatchToProps = {
  activateDatadic,activateScreen,activateFiname ,activateRecord ,activateStocks,
};

const SaveFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveFilterclass);

export default SaveFilter;
